module.exports = __webpack_public_path__ + "img/500.b4d10878.jpg";